import { parseRetryAfterSeconds } from './parse-retry-after-seconds.function';

/**
 * Parses an HTTP `Retry-After` header into a delay in milliseconds.
 * Falls back to `defaultMs` (1000) when the header is absent or invalid.
 */
export function parseRetryAfterMs(
  header: string | null | undefined,
  options?: { defaultMs?: number; now?: number },
): number {
  const seconds = parseRetryAfterSeconds(header, options?.now ?? Date.now());
  if (seconds === undefined) {
    return options?.defaultMs ?? 1000;
  }

  return seconds * 1000;
}
